var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcError = function SvgIcError(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_error",
    d: "M15.375,3.375a12,12,0,1,0,12,12A12,12,0,0,0,15.375,3.375Zm3.04,16.344-3.04-3.04-3.04,3.04a.922.922,0,1,1-1.3-1.3l3.04-3.04-3.04-3.04a.922.922,0,0,1,1.3-1.3l3.04,3.04,3.04-3.04a.922.922,0,0,1,1.3,1.3l-3.04,3.04,3.04,3.04a.926.926,0,0,1,0,1.3A.916.916,0,0,1,18.415,19.719Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#db2828"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_error.3dc46bf5.svg";
export { ForwardRef as ReactComponent };